<template>
  <div>
    <highcharts :options="chartOptions" />
    <div id="svg-chart" hidden />
  </div>
</template>

<script>
import { Chart } from 'highcharts-vue';
import Drilldown from 'highcharts/modules/drilldown';
import Highcharts from 'highcharts';

Drilldown(Highcharts);

export default {
  name: 'PieChart',

  components: {
    highcharts: Chart,
  },

  props: {
    titulo: {
      type: String,
      required: true,
      default: '',
    },
    fonte: {
      type: String,
      required: false,
      default: 'Fonte: Sistema Desenvolva',
    },
    dados: {
      type: Array,
      required: true,
    },
    dadosComplementares: {
      type: Array,
      required: false,
      default: () => [],
    },
    isGetSvg: {
      type: Boolean,
      required: false,
      default: false,
    },
    cores: {
      type: Array,
      required: false,
      default() {
        return ['#348ECA', '#2D5269', '#00ABA4', '#f8d58b', '#f0656b', '#00565c', '#008b92', '#e9866d', '#e66260'];
      },
    },
    tooltip: {
      type: Object,
      required: false,
      default() {
        return {
          headerFormat: '<span style="font-weight:bold">{series.name}</span><br>',
          pointFormat:
            '<span style="color:{point.color};font-weight:bold">{point.name}</span>: '
            + '{point.percentage:.2f}% do total ({point.y} de {point.total})',
        };
      },
    },
    plotOptions: {
      type: Object,
      required: false,
      default() {
        return {
          series: {
            dataLabels: {
              enabled: true,
              format: '{point.name} ({point.y}): {point.percentage:.2f}%',
            },
          },
          pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            colors: this.cores,
            size: '80%',
            dataLabels: {
              crop: false,
              overflow: 'allow',
            },
          },
        };
      },
    },
  },

  computed: {
    chartOptions() {
      return {
        chart: {
          type: 'pie',
          style: {
            fontFamily: 'Roboto;Arial;sans-serif',
          },
          events: {
            render() {
              const chart = this;

              if (chart.fullscreen.isOpen && chart.fullscreenStatus === 'fullscreen: off') {
                chart.fullscreenStatus = 'fullscreen: on';

                chart.update({
                  chart: {
                    marginBottom: window.screen.height * 0.2,
                    height: window.screen.height,
                  },
                  plotOptions: {
                    series: {
                      dataLabels: {
                        style: {
                          fontSize: '20px',
                        },
                      },
                    },
                  },
                  tooltip: {
                    style: {
                      fontSize: '20px',
                    },
                  },
                });
              }

              if (!chart.fullscreen.isOpen && chart.fullscreenStatus === 'fullscreen: on') {
                chart.fullscreenStatus = 'fullscreen: off';

                chart.update({
                  chart: {
                    marginBottom: chart.initialPlotBottom,
                    height: 400,
                  },
                  plotOptions: {
                    series: {
                      dataLabels: {
                        style: {
                          fontSize: '12px',
                        },
                      },
                    },
                  },
                  tooltip: {
                    outside: true,
                    style: {
                      fontSize: '12px',
                    },
                  },
                });
              }
            },
            load() {
              const chart = this;
              chart.initialPlotBottom = chart.plotBottom;
              chart.fullscreenStatus = 'fullscreen: off';
            },
          },
        },
        exporting: {
          sourceWidth: 900,
          menuItemDefinitions: {
            viewFullscreen: {
              textKey: 'viewFullscreen',
              onclick() {
                this.update({
                  tooltip: {
                    outside: this.fullscreen.isOpen,
                  },
                });
                this.fullscreen.toggle();
              },
            },
          },
        },
        credits: {
          enabled: true,
        },
        title: {
          text: this.titulo,
          allowHTML: true,
        },
        subtitle: {
          text: this.fonte,
        },
        plotOptions: this.plotOptions,
        tooltip: this.tooltip,
        lang: {
          contextButtonTitle: 'Opções do Gráfico',
          decimalPoint: ',',
          viewFullscreen: 'Ver em Tela Cheia',
          printChart: 'Imprimir Gráfico',
          downloadJPEG: 'Baixar como Imagem JPEG',
          downloadPNG: 'Baixar como Imagem PNG',
          downloadPDF: 'Baixar como Documento PDF',
          downloadSVG: 'Baixar como Vetor de Imagem SVG',
          exitFullscreen: 'Sair do modo Tela Cheia',
          loading: 'Carregando...',
          noData: 'Não há dados disponíveis',
          drillUpText: '◁ Voltar para {series.name}',
        },
        series: this.dados,
        drilldown: {
          series: this.dadosComplementares,
        },
      };
    },
  },

  watch: {
    isGetSvg(value) {
      if (value) {
        this.$emit('svg', Highcharts.chart('svg-chart', this.chartOptions).getSVG());
      }
    },
  },
};
</script>
